/**
 * @generated SignedSource<<d56f0d629f07e6341bae3add881882cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type summaryLiveArticleSummaryLiveContent$data = ReadonlyArray<{
  readonly customTime: number | null | undefined;
  readonly entityUuid: string;
  readonly summary: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleSummaryLiveContent">;
  readonly " $fragmentType": "summaryLiveArticleSummaryLiveContent";
}>;
export type summaryLiveArticleSummaryLiveContent$key = ReadonlyArray<{
  readonly " $data"?: summaryLiveArticleSummaryLiveContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"summaryLiveArticleSummaryLiveContent">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "summaryLiveArticleSummaryLiveContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "itemLiveArticleSummaryLiveContent"
    }
  ],
  "type": "LiveContent",
  "abstractKey": null
};

(node as any).hash = "1fb15147c3d963c9d054547f665dcc96";

export default node;
